export const Institutions = {
  OSU: 'OREGSTU',
};
